module.exports = __webpack_public_path__ + "static/media/Asset 19.400e07ff.svg";